import DeviceIpAddressesPage from './device-ip-addresses-page';

export default DeviceIpAddressesPage;